/* modalSlice.ts */

/* Redux Toolkit */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

/* Constantas */
import { ModalType } from "src/shared/constants/common/Modal";

interface ModalProps {
  modalType: ModalType;
  showModal: boolean;
  className?: string;
}

export const initialState: ModalProps = {
  modalType: ModalType.DEFAULT,
  showModal: false,
  className: "",
};

export const modalSlice = createSlice({
  name: "modalSlice",
  initialState: initialState,
  reducers: {
    setShowModal: (
      state,
      action: PayloadAction<ModalProps>
    ) => {
      state.modalType = action.payload.modalType;
      state.showModal = action.payload.showModal;
      state.className = action.payload.className || "";
    },
  },
});

/* Action */
export const { setShowModal } = modalSlice.actions;

/* Reducer */
export default modalSlice.reducer;
